'use client';
import type { Card } from '@/modules/FinancialPlanning/ui/Widgets/Home';
import type { FC } from 'react';
import Link from 'next/link';
import { Close, OpenInNewTabAlternative } from '@eqi-investimentos/icons/web';
import { Box, Flex, IconButton, Text } from '@eqi-investimentos/react';
import { Collapse, Fade, useDisclosure } from '@chakra-ui/react';
import { Icon } from '../Icon';

export const FloatingButton: FC<FloatingButtonProps> = ({ options }) => {
  const { isOpen, onToggle } = useDisclosure();

  return (
    <>
      <Fade in={isOpen} unmountOnExit transition={{ enter: { delay: -0.5 } }}>
        <Box
          position="fixed"
          top="0"
          left="0"
          w="100vw"
          h="100vh"
          bg="blackAlpha.800"
          zIndex={isOpen ? 'overlay' : 'docked'}
          onClick={onToggle}
        />
      </Fade>
      <Box
        position="fixed"
        bottom="xl"
        right="6rem"
        zIndex={isOpen ? 'overlay' : 'docked'}
      >
        <Flex
          direction="column"
          gap="m"
          alignItems="flex-end"
          color="content.alwaysLight"
        >
          {Array.isArray(options) &&
            options.map(({ text, icon, href, comming_soon }) => (
              <Collapse key={text} in={isOpen} unmountOnExit animateOpacity>
                <Flex
                  as={Link}
                  href={href}
                  onClick={onToggle}
                  gap="s"
                  alignItems="center"
                  _hover={{
                    color: 'action.hover.brandLight',
                    '& button': {
                      bgColor: 'action.hover.brandLight',
                      color: 'content.brandHigh',
                    },
                  }}
                >
                  <Text size="l">
                    {comming_soon ? text + ' (em breve)' : text}
                  </Text>
                  <IconButton
                    aria-label={text}
                    isDisabled={!!comming_soon}
                    icon={<Icon iconName={icon} {...iconProps} />}
                    {...buttonProps}
                  />
                </Flex>
              </Collapse>
            ))}
          <IconButton
            icon={
              isOpen ? (
                <Close {...iconProps} />
              ) : (
                <OpenInNewTabAlternative
                  {...iconProps}
                  transform="rotate(-90deg)"
                />
              )
            }
            onClick={onToggle}
            aria-label="Abrir menu flutuante"
            _hover={{
              bgColor: 'action.hover.brandLight',
              color: 'content.brandHigh',
            }}
            {...buttonProps}
          />
        </Flex>
      </Box>
    </>
  );
};

const buttonProps = {
  justifyContent: 'center',
  boxSize: '3.25rem',
  borderRadius: 'full',
  bgColor: 'content.brand',
  color: 'content.inverse',
};

const iconProps = {
  w: '1.5rem !important',
  h: '1.5rem !important',
};

type FloatingButtonProps = {
  options?: Card[];
};
